<template>
  <div id="role-dialog" class="zoom-anim-dialog mfp-hide">
    <div class="small-dialog-header">
      <h3>قوانین و مقررات</h3>
    </div>
    <form>
      <div class="sign-in-wrapper">
        <div style="padding: 0px 15px 0px 15px;overflow-y: auto;
    overflow-x: hidden;
    max-height: 620px;font-size: 15px; line-height: 2;">

          <div>
            <div v-if="roleType === 'hotel-flight' || roleType === 'hotel'">
              <div style="    color: #2565c0;" class="row"><i style="font-size: 26px;margin-top: 9px;"
                  class=" icon-warehouse"></i>

                <h3 style="font-size: 15px;font-weight: bold;    margin-top: 27px;">قوانین و مقررات هتل</h3>
              </div>
              <p v-html="hotelInfo.hotelDetail.hotelPolicy">

              </p>

              <h3 style="font-size: 15px;font-weight: bold;">قوانین کنسلی هتل</h3>
              <p>
                <!-- ﻣﻬﻠﺖ ﮐﻨﺴﻞ ﮐﺮدن ﺑﺪون ﺟﺮﯾﻤﻪ {{ hotelInfo.hotelDetail.cancelTerm }} روز ﻗﺒﻞ از ﺗﺎرﯾﺦ ورود. -->
                ﻣﻬﻠﺖ ﮐﻨﺴﻞ ﮐﺮدن ﺑﺪون ﺟﺮﯾﻤﻪ تا 7 روز ﻗﺒﻞ از ﺗﺎرﯾﺦ ورود.
              </p>
              <p v-html="hotelInfo.hotelDetail.cancelPolicy">

              </p>



              <p v-html="hotelInfo.hotelDetail.voucherText">

              </p>


            </div>

            <div v-if="roleType === 'hotel-flight' || roleType === 'flight'">


              <div style=" color: #2565c0;" class="row"><i style="font-size: 26px;margin-top: 11px;"
                  class=" icon-flight-1"></i>
                <h3 style="font-size: 15px;font-weight: bold;margin-top: 26px;">قوانین و مقررات پرواز</h3>
              </div>

              <p>
              <ul>
                <label> در هنگام مراجعه به فرودگاه به همراه داشتن بلیت و یا شماره سریال بلیت تمامی مسافران، به همراه
                  کارت ملی (اتباع ایرانی) و یا گذرنامه (اتباع خارجی) الزامی است.</label>
                <li>
                  تمامی «پروازهای داخلی شرکت هواپیمایی زاگرس» در ترمینال شماره یک فرودگاه بین المللی مهرآباد و «پروازهای
                  بین المللی شرکت هواپیمایی زاگرس» در فرودگاه امام خمینی(ره) انجام می شود.
                </li>
                <li>
                  بارمجاز برای مسافران پروازهای داخلی «20 کیلوگرم» و برای مسافران پروازهای خارجی «25 کیلوگرم» است.
                </li>
                <li>
                  حضور مسافر در پروازهای داخلی 2 ساعت و درپروازهای خارجی 3 ساعت قبل از پرواز الزامیست
                  کالاهای خطرناک
                </li>
              </ul>

              بر اساس ابلاغیه رسمی سازمان هواپیمایی کشوری در خصوص مقررات حمل هوایی کالاهای خطرناک همراه مسافر، انتقال
              هرگونه سیگار الکترونیکی در بار همراه مسافر(Checked Baggage ) به داخل (CARGO ) هواپیما ممنوع بوده و مسافران
              مجاز به حمل ادوات فوق الذکر، همراه خود به داخل کابین هواپیما می باشند.
              همچنین توصیه می شود مسافران گرامی، از قرار دادن دوربین، موبایل، نوت بوک، اشیای گران بها و مدارک مهم در
              بسته های تحویلی به هواپیما خودداری فرمایید. در غیر این صورت، هواپیمایی زاگرس در خصوص مفقود و یا مخدوش شدن
              موارد فوق هیچ گونه مسئولیتی ندارد.
              خرید بلیط از سایت شرکت هواپیمایی زاگرس مختص عموم می باشد. در صورت خرید بلیط توسط دفاتر خدمات مسافرتی و
              صدور بلیط متفرقه توسط آنها ، شرکت هواپیمایی زاگرس هیچگونه مسئولیتی در قبال عدم پذیرش مسافر نخواهد داشت.

              </p>
              <h3 style="font-size: 15px;font-weight: bold;">

                استرداد:</h3>
              <p>
                وجه استرداد بلیت فقط به شماره کارت مسافر مسترد می گردد</p>
              <p>ھرگونه تغییر در پرواز داخلي شامل جريمه بوده و درصد جريمه مطابق جدول روبرو مي باشد</p>
              <p>جرايم کلاس ھاي نرخي دو حرفي بر اساس حرف اول کلاس نرخي مربوطه محاسبه مي شود</p>
              <div class="row">
                <div class="col-12">

                  <table colspan="12" style="text-align: center;font-size: 15px; width: 100%; vertical-align: middle;"
                    class="base-tables">
                    <thead>
                      <tr>
                        <th colspan="2" class="right">شناسه نرخی (کلاس) </th>

                        <th class=" addon-tb">از زمان صدور تا15 دقیقه پس از آن 1</th>
                        <th class=" addon-tb"> از 15دقیقه پس از صدور تا 12 ظهر 3روز قبل از پرواز</th>
                        <th class=" addon-tb">تا 12 ظهر یک روز قبل از پرواز </th>
                        <th class=" addon-tb">تا 3 ساعت قبل از پرواز </th>
                        <th class=" addon-tb">از 3 ساعت قبل از پرواز به بعد </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>

                        <td rowspan="1" class="addon-tb">
                          بیزینس

                        </td>
                        <td class="addon-tb">
                          D,I,Z
                        </td>
                        <td class="addon-tb">
                          0
                        </td>
                        <td class="addon-tb">
                          20
                        </td>
                        <td class="addon-tb">
                          30
                        </td>
                        <td class="addon-tb">
                          50
                        </td>
                        <td class="addon-tb">
                          50
                        </td>
                      </tr>
                      <tr>

                        <td rowspan="3" class="addon-tb border-end">
                          اکونومی
                        </td>

                        <td class="addon-tb">M,N,Q,X,R,U,V,W,Y</td>
                        <td class="addon-tb">
                          0
                        </td>
                        <td class="addon-tb">
                          30
                        </td>
                        <td class="addon-tb">
                          40
                        </td>
                        <td class="addon-tb">
                          50
                        </td>
                        <td class="addon-tb">
                          60
                        </td>

                      </tr>
                      <tr>
                        <td class="addon-tb">
                          H,K,L
                        </td>
                        <td class="addon-tb">
                          0
                        </td>
                        <td class="addon-tb">
                          40
                        </td>
                        <td class="addon-tb">
                          50
                        </td>
                        <td class="addon-tb">
                          60
                        </td>
                        <td class="addon-tb">
                          70
                        </td>
                      </tr>
                      <tr>
                        <td class="addon-tb">
                          O,E,B
                        </td>
                        <td class="addon-tb">
                          0
                        </td>
                        <td class="addon-tb">
                          50
                        </td>
                        <td class="addon-tb">
                          60
                        </td>
                        <td class="addon-tb">
                          80
                        </td>
                        <td class="addon-tb">
                          90
                        </td>
                      </tr>
                    </tbody>


                  </table>
                  
                </div>
              </div>

            </div>
            <!-- <ul>
<h5>مسافران محترم درصورتی که دچار بیماری هستند، قبل از اقدام به سفرهوایی ملزم به اجرای اقدامات زیر می باشند </h5>

  <li>
مراجعه به دفاترفروش
  </li>
  <li>
اعلام بیماری یا نیاز به ارائه خدمات ویژه توسط کارکنان شرکت درهنگام انتقال مسافر به هواپیمادرفرودگاه های مبدا و مقصد
  </li>
  <li>
تحویل فرم اطلاعات پزشکی به مسافرتوسط دفتر فروش بلیت
  </li>
  <li>
تکمیل فرم اطلاعات پزشکی توسط پزشک معالج بیمار با مهر و امضای پزشک معالج
  </li>
  <li>
تایید نهایی فرم اطلاعات پزشکی توسط پزشک هوایی شرکت
  </li>
</ul> -->

          </div>
          <!-- <div class="text-center">
          <button id="close" style="width: 120px;"
 class="btn btn-primary">تایید</button>
        </div> -->
        </div>
      </div>
    </form>
  </div>
</template>


<script>
import $ from "jquery";
import store from "@/views/profile/store/index";

var qs = require("qs");

export default {
  name: "PdkRole",
  store: store,
  components: {
  },

  data() {
    return {

      popup: {

      },

      id: "",
      isLoading: false,
    };
  },

  props: {
    roleType: {
      type: String,
      default: () => "hotel-flight",
    },
    hotelDetail: {
      type: Object,
      default: () => { },
    }
  },

  created() {
    if (this.roleType === undefined) {
      this.roleType === 'hotel';
    }
  },
  mounted: function () {
    require("magnific-popup");
    $("#close").on("click", function () {
      $.magnificPopup.close();
    });
    this.popup = $(this.$el.querySelector("#role_link")).magnificPopup({
      type: "inline",
      fixedContentPos: true,
      fixedBgPos: true,
      overflowY: "auto",
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: "my-mfp-zoom-in",
    });
  },

  methods: {
    close() {
      $.magnificPopup.close();
    },
  },

  computed: {
    hotelInfo() {

      return this.hotelDetail = this.hotelDetail;
    }
  }
};
</script>
<style scoped>
.invalid {
  border: 1px solid red !important;
  box-shadow: 0 0 5px red !important;
}

.loading-btn {
  padding-right: 50px !important;
}

table,
th,
td {
  border: 1px solid #ccc;

}

.base-tables {
  direction: rtl;
  border-radius: 20px;
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;

}

.table thead th {
  vertical-align: unset !important;
  border-bottom: 2px solid #dee2e6;
}

table th {
  background-color: #07294e;
  color: #ffffff;
}

.addon-tb {
  padding: 1em 0em !important;
  text-align: center;
}

.base-tables tbody tr:last-child td:first-child {
  border-radius: 0 !important;
}
.rtl th, [dir=rtl] th {
    text-align: center !important;
}
.border-end {
    border-end-start-radius: 15px !important;
}
</style>